var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sb-menu--item"},[_c('notification',{attrs:{"visible":_vm.notification}}),_vm._t("default"),_vm._v(" "+_vm._s(_vm.text)+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }